export default "__VITE_ASSET__AgO9d$3V__"